import { IContent } from '@/study-search/interfaces/content.interface';
import { IFaq, IStaticContentUrl } from '@studyportals/domain-client';

export class Content implements IContent {
	public constructor(
		public readonly id: string,
		public readonly faqs: IFaq[],
		public readonly staticContentText: string,
		public readonly staticContentUrls: IStaticContentUrl[]
	) { }
}